import type { DeckDecorationLanguages } from "../../../../constants/deckDecoration";
import type { G4sPlacement } from "../../../../constants/g4sPlacement";

import type { Email } from "./createEmail";

export interface CreateDeckDecorationRequest {
    salesforceAccountId: string;
    marketplaceId: string;
    documentUrl: string;
    outputOptions: DecorationOutputType[];
    customizationOptions?: DecorationCustomizationOption;
    prompt?: string;
    placement: G4sPlacement;
}

export interface CreateDeckDecorationResponse {
    id: string;
    status: number;
    body: Decoration;
}

export type Decoration = {
    email: Email;
    summary: Summary;
    error_message?: string;
};

export type Summary = {
    body: string;
};

export type DecorationCustomizationOption = {
    language?: DeckDecorationLanguages;
    emailSize?: DecorationEmailSize;
    tone?: string;
};

export enum DecorationOutputType {
    EMAIL = "email",
    SUMMARY = "summary",
}

export enum DecorationEmailSize {
    SHORT = "short",
    MEDIUM = "medium",
    LONG = "long",
}
